const PATHNAME_EXCLUDE_AQI_BAR = [
  '/dp/[...slug]',
  '/amc-plans/[assetId]/[planId]',
  '/cart',
  '/payment',
  '/payment/failure',
  '/payment/success',
  '/service',
  '/service/[assetId]',
  '/ecom/payment/[...slug]',
  '/ecom/payment/[orderId]',
  '/ecom/payment/success/[orderId]',
  '/ecom/payment/failure/[orderId]',
  '/amc/cc/agent',
  '/amc-service-plans/[assetId]/[planId]',
];

export const showAQIBar = (pathname: string) => {
  if (PATHNAME_EXCLUDE_AQI_BAR.includes(pathname)) {
    return false;
  }
  return true;
};
